import React                     from 'react';
import { Observe }               from 'rewire-core';
import { WithStyle }             from 'rewire-ui';
import classNames                from 'classnames';
import Typography                from '@material-ui/core/Typography';
import Button                    from '@material-ui/core/Button';
import { Theme }                 from '@material-ui/core/styles';
import { ArrowLeftCircleOutline as BackIcon, ArrowRightCircleOutline as ForwardIcon } from 'mdi-material-ui';
import infoPanelShiftViewModel   from './InfoPanelShiftViewModel';
import { withStyles }            from '../utility/styles';

const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    marginRight: '10px',
  },
  shiftCount: {
    paddingLeft: '8px',
  },
  button: {
    minWidth: '0px',
  },
});

interface IShiftNavigationProps {
  className?: string;
  classes?:   any;
  title?:     string;
}

type ShiftNavigationProps = WithStyle<ReturnType<typeof styles>, IShiftNavigationProps>;

class InfoPanelShiftNavigation extends React.PureComponent<ShiftNavigationProps> {
  constructor(props: ShiftNavigationProps) {
    super(props);
  }

  render() {
    const {classes, className, title} = this.props;

    return <Observe render={() => (
      <div className={classNames(classes.root, className)}>
        {title && <Typography className={classes.title} variant='h6'>{title}</Typography>}
        <Button
          className={classes.button}
          variant  = 'text'
          disabled = {!infoPanelShiftViewModel.canNavigateBack()}
          title    = {infoPanelShiftViewModel.navigateBackTitle}
          onClick  = {() => infoPanelShiftViewModel.navigateBack()}>
          <BackIcon />
        </Button>
        <Button
          className={classes.button}
          variant  = 'text'
          disabled = {!infoPanelShiftViewModel.canNavigateForward()}
          title    = {infoPanelShiftViewModel.navigateForwardTitle}
          onClick  = {() => infoPanelShiftViewModel.navigateForward()}>
          <ForwardIcon />
        </Button>
        <Typography variant='h6' className={classes.shiftCount}>{`${infoPanelShiftViewModel.currentInnerShiftIdx + 1}/${infoPanelShiftViewModel.innerShifts.length}`}</Typography>
      </div>
    )} />;
  }
}

export default withStyles<IShiftNavigationProps>(styles, InfoPanelShiftNavigation);
